<template>
	<div class="galaxy">
		<div class="header" id="demo">
		  	<div class="canvaszz"></div>
		  	<canvas id="canvas"></canvas>
		</div>
		<div class="contain clearfix">
			<div class="galaxy-title">
				新鲜入驻媒介
			</div>
			<div class="galaxy-content">
				新鲜站，新视野，与广大站长和广告主实现共赢
			</div>
			<img src="/static/huaban.png" alt="Planets"  />
			<img class="heidong" src="/static/blackdong.png" alt="" title='点击刷新媒介' @click='reload()'>
			<div style="position:absolute;top:335px;left:46.4%;cursor:pointer;width: 28px;" @click='reload()' id="reload">点击刷新</div>
			<transition-group name="flip-list" tag='div'>
				<div class="media-point" v-for='(item, index) in data' :key='item' :style='{ top: site[index][0], left: site[index][1]}'>
					<a :href="item.previewUrl" target="_blank" v-if='$route.params.type === "web"'>{{item.siteName}}</a>
					<div style='cursor: default' v-else>{{item.siteName}}</div>
				</div>
			</transition-group>
		</div>
	</div>
</template>
<script>
	export default {
		data () {
			return {
				data: [],
				site: [['279px', '120px'], ['433px', '150px'], ['160px', '370px'], ['230px', '470px'], ['168px', '700px'], ['485px', '600px'], ['464px', '800px'], ['520px', '940px'], ['212px', '976px'], ['341px', '945px']]
			}
		},
		watch: {
			'$route' (to, from) {
				this.getNewList()
			}
		},
		mounted () {
			/* eslint-disable */
			this.getNewList()
			let canvas = document.getElementById('canvas')
			let ctx = canvas.getContext('2d')
			let w = canvas.width = window.innerWidth
			let h = canvas.height = window.innerHeight
			let hue = 217
			let stars = []
			let count = 0
			let maxStars = 500
			let canvas2 = document.createElement('canvas')
			let ctx2 = canvas2.getContext('2d')
			canvas2.width = 100
			canvas2.height = 100
			let half = canvas2.width / 2
			let gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half)
			gradient2.addColorStop(0.025, '#CCC')
			gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)')
			gradient2.addColorStop(0.25, 'hsl(' + hue + ', 64%, 6%)')
			gradient2.addColorStop(1, 'transparent')

			ctx2.fillStyle = gradient2
			ctx2.beginPath()
			ctx2.arc(half, half, half, 0, Math.PI * 2)
			ctx2.fill()
			function random (min, max) {
				if (arguments.length < 2) {
				    max = min
				    min = 0
				  }

				  if (min > max) {
				    var hold = max
				    max = min
				    min = hold
				  }
  				return Math.floor(Math.random() * (max - min + 1)) + min
			}
			function maxOrbit (x, y) {
				let max = Math.max(x, y)
				let diameter = Math.round(Math.sqrt(max * max + max * max))
				return diameter / 2
			}
			let Star = function () {
				this.orbitRadius = random(maxOrbit(w, h))
				this.radius = random(60, this.orbitRadius) / 8
				this.orbitX = w / 2
				this.orbitY = h / 2
				this.timePassed = random(0, maxStars)
				this.speed = random(this.orbitRadius) / 50000
				this.alpha = random(2, 10) / 10

				count++
				stars[count] = this
			}
			Star.prototype.draw = function () {
				var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX
			    var y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY
			    var twinkle = random(10)

				if (twinkle === 1 && this.alpha > 0) {
				    this.alpha -= 0.05
				} else if (twinkle === 2 && this.alpha < 1) {
				    this.alpha += 0.05
				}

				ctx.globalAlpha = this.alpha
				ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius)
				this.timePassed += this.speed
			}
			for (var i = 0; i < maxStars; i++) {
			  	new Star()
			}
			function animation () {
				ctx.globalCompositeOperation = 'source-over'
			  	ctx.globalAlpha = 0.5
			  	ctx.fillStyle = 'hsla(' + hue + ', 64%, 6%, 2)'
			  	ctx.fillRect(0, 0, w, h)
			  	ctx.globalCompositeOperation = 'lighter'
			  	for (let i = 1, l = stars.length; i < l; i++) {
			    	stars[i].draw()
			  	}
			  	window.requestAnimationFrame(animation)
			}
			animation()
		},
		methods: {
			getNewList () {
				this.$http.get(`${this.baseUrl}newin`, {params: {type: this.$route.params.type === 'web' ? 1 : 2, page: 1, pagesize: 10}})
				.then((res) => {
					this.$set(this, 'data', JSON.parse(res.data).result)
				})
				this.$set(this, 'data', this.data.reverse())
			},
			reload () {
				this.getNewList()
			}
		}
	}
</script>

<style lang='less'>
#canvas{
	width: 100%;
	height: 100%;
}
.flip-list-move {
  transition: transform 1s;
}
.galaxy-title{
	font-size: 26px;
	top: 50px;
	text-align: center;
}
.media-point{
	cursor: pointer;
	position: absolute;
}
.galaxy-content{
	margin-top: 30px;
	text-align: center;
}
.heidong{
	cursor: pointer;
	position: absolute;
	left: 520px;
	top: 300px;
	transition: all 0.8s;
}
.heidong:hover{
	transform: scale(2, 2);
}
.galaxy{
	width: 100%;
	overflow: hidden;
	position:relative;
	.contain{
		color: white;
		z-index: 100;
		position: relative;
		top: -580px;
		img{
			position: absolute;
		}
	}
	.header{
	margin:0 auto;
	width:100%;
	height:625px;
	canvas{
		width:100%;
		display:inline-block;
		vertical-align:baseline;
		position:absolute;
		z-index:1;
	}
	.canvaszz{
		width:100%;
		background: url(/static/galaxy.jpg) top center no-repeat;
		height:709px;
		position:absolute;
		z-index:10;
      	opacity: 0.4;
    }
    .top_logo{
		margin:0 auto;
		width:750px;
		height:200px;
		position:absolute;
		z-index:30;
		top:10px;
		left: 50%;
		margin-left: -390px;
	}
	.nav{
		width:804px;
		height:auto;
		position:absolute;
		z-index:30;
		top:420px;
		left: 50%;
		margin-left: -400px;
		a{
			.gv{
				text-decoration:none; 
				width: 130px; 
				height: 43px; 
				display: block; 
				text-align:center;		/*水平居中*/
				line-height:43px;  /*上下居中*/
				cursor:pointer;
				float:left;/*左浮动*/
				margin:8px 2px 8px 2px;
				font:18px/43px 'microsoft yahei'; 
				color:#066197;
				span{
					display: none;
				}
			}
			.gv:hover{
				color:#1d7eb8;
				transition-duration: 0.5s;
			}
		}
	}
	.topcn{
		width: 980px;
		top:200px;
		left: 50%;
		margin-left: -490px;
		position:absolute;
		z-index:20;
	}
}
}
</style>



// WEBPACK FOOTER //
// galaxy.vue?66e5d8de